import { IAnexoPedido } from "../../pedidos/interface/IAnexoPedido";

export enum ModeloNotaFiscal {
    NFE = "55",
    NFCE = "65",
}

export const ModeloNotaFiscalDescricao: Record<ModeloNotaFiscal, string> = {
    [ModeloNotaFiscal.NFE]: "NF-e",
    [ModeloNotaFiscal.NFCE]: "NFC-e",
};

export interface INFCe {
    uuid: string;
    estabelecimentoUuid: string;
    dataHora: string;
    modelo?: ModeloNotaFiscal;
    destinatarioNome?: string;
    destinatarioDocumento?: string;
    chaveNfe: string;
    cnpjEmitente: string;
    mensagemSefaz: string;
    numero: string;
    serie: string;
    qrcodeUrl: string;
    ref: string;
    status: string;
    statusSefaz: string;
    urlConsultaNf: string;
    protocolo: string;
    xml: IAnexoPedido;
    pdf: IAnexoPedido;
}